module.exports = __webpack_public_path__ + "media/images/promo/championship/icon_1-e14b4b1b4d14dcfda96922fae08fde71.png";